/* eslint-disable prettier/prettier */
export default {
  duringVisit: {
    updateApp: "You'll need to update your app to access your video visit",
    subText: {
      asapBookingActiveMembership: 'A provider will be ready to see you soon.',
      asapBookingNonActiveMembership: `We\'ve sent your information to {{ displayNamePrimary }}. A provider will be ready to see you soon.`,
      nonAsapBookingActiveMembership: 'Please join the video visit 15 minutes before your visit ',
      nonAsapBookingNonActiveMembership: `We\'ve sent your information to {{ displayNamePrimary }}. Please join the video visit 15 minutes before your visit `,
    },
    joinCall: 'Join the Call',
    thankYou: 'Thank You',
  },
  postVisit: {
    title: 'Video visit complete',
    audioPrompt: 'How was your audio quality?',
    videoPrompt: 'How was your video quality?',
    combinedQualityPrompt: 'How was your video and audio quality?',
    providerPrompt: 'How was your experience with the provider?',
    commentPlaceholder: 'Anything else you’d like to mention?',
    backPrompt: 'Return To Call',
    primaryAction: 'Submit',
    contactUs: 'Having issues? Need anything? <br> Email us at: <1>{{email}}</1>',
    feedback: 'We appreciate your feedback.',
  },
};
